    <h1 mat-dialog-title>{{data.isEdit ? 'Editar' : 'Agregar'}} Agencia</h1>
    <div mat-dialog-content>
      <mat-form-field appearance="fill">
        <mat-label>Nombre</mat-label>
        <input matInput [(ngModel)]="agency.name" required>
      </mat-form-field>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onCancel()">Cancelar</button>
      <button mat-raised-button color="primary" [disabled]="!isValid()" (click)="onSave()">Guardar</button>
    </div>
